import React, {useEffect, useState} from 'react'
import {Field} from 'formik'
import {getProductFilters} from '../../core/_requests'
import {ProductFilters} from '../../core/_models'
import {useIntl} from 'react-intl'

import {
  CustomSelect
} from '@/components/form'

const initialFilters = {
  status: 'PUBLISHED',
  type: '',
  stock: ''
}

const FilterForm = () => {
  const intl = useIntl()
  const [options, setOptions] = useState<ProductFilters|undefined>()


  useEffect(() => {
    const load = async () => {
      setOptions(await getProductFilters())
    }

    if (options === undefined) {
      load()
    }
  }, [options])

  return (
    <>
      <Field
        default="Select status"
        component={CustomSelect}
        label="Status"
        name="status"
        options={(options?.statuses || []).map((t:string) => {
          return { value: t, label: intl.formatMessage({id: `P2C.PRODUCT_STATUS_${t}`})}
        })}
      />

      <Field
        default="Select type"
        component={CustomSelect}
        label="Type"
        name="type"
        options={(options?.types || []).map((t:string) => {
          return { value: t, label: intl.formatMessage({id: `P2C.PRODUCT_TYPE_${t}`})}
        })}
      />

      <Field
        default="Select category"
        component={CustomSelect}
        label="Category"
        name="category"
        options={(options?.categories || []).map((t:string) => {
          return { value: t, label: intl.formatMessage({id: `P2C.PRODUCT_CATEGORY_${t}`})}
        })}
      />

      <Field
        default="Select platform"
        component={CustomSelect}
        label="Platform"
        name="platform"
        options={(options?.platforms || []).map((t:string) => {
          return { value: t, label: t.split('_').at(-1) }
        })}
      />

      <Field
        default="Select stock"
        component={CustomSelect}
        label="Stock"
        name="stock"
        options={['IN_STOCK', 'OUT_STOCK', 'LOW_STOCK'].map((t:string) => {
          return { value: t, label: intl.formatMessage({id: t})}
        })}
      />
    </>
  )
}

export {FilterForm, initialFilters}
